/**
 * JWT Token 工具函数
 */

/**
 * 解析 JWT Token，获取 payload
 * @param {string} token - JWT Token
 * @returns {object|null} - Token payload 或 null
 */
export function parseJWT(token) {
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("解析JWT Token失败:", e);
    return null;
  }
}

/**
 * 获取 Token 过期时间（时间戳，毫秒）
 * @param {string} token - JWT Token
 * @returns {number|null} - 过期时间戳或 null
 */
export function getTokenExpiration(token) {
  const payload = parseJWT(token);
  if (!payload || !payload.exp) return null;
  // JWT 的 exp 是秒级时间戳，需要转换为毫秒
  return payload.exp * 1000;
}

/**
 * 检查 Token 是否即将过期
 * @param {string} token - JWT Token
 * @param {number} thresholdSeconds - 阈值（秒），默认 7200（2小时）
 * @returns {boolean} - 是否即将过期
 */
export function isTokenExpiringSoon(token, thresholdSeconds = 7200) {
  const expiration = getTokenExpiration(token);
  if (!expiration) return true;
  const now = Date.now();
  const remaining = expiration - now;
  return remaining < thresholdSeconds * 1000;
}

/**
 * 获取 Token 剩余时间（秒）
 * @param {string} token - JWT Token
 * @returns {number|null} - 剩余时间（秒）或 null
 */
export function getTokenRemainingTime(token) {
  const expiration = getTokenExpiration(token);
  if (!expiration) return null;
  const now = Date.now();
  const remaining = expiration - now;
  return Math.max(0, Math.floor(remaining / 1000));
}
